import { Col, Row } from 'antd';
import React from 'react'
import Footer from '../../../components/common/Footer';
import PageHeading from '../../../components/common/PageHeading';
import RightBar from '../../../components/common/RightBar';
import { accountingRoles, leasingRoles, maintenanceRoles, managementRoles, miscSupportRoles, propertyManagementRoles } from '../../../data/roles';
import Roles from './Roles';

import './ManageRoles.css';

const UserRolesAndPermissionsRightBar = [];

function ManageRoles() {
  return (
    <>
      <div className='page-container'>
      <div className="manage-roles main-container">
        <PageHeading heading="Manage Roles" />
       <Row>
       <Col span={24} className="management-roles">
          <Roles roleTitle="Management Roles" roleIndex="managementRole" roleKey="managementRole" data={managementRoles} />
          <Roles roleTitle="Accounting Roles" roleIndex="accountingRole" roleKey="accountingRole" data={accountingRoles} />
          <Roles roleTitle="Property Management Roles" roleIndex="propertyManagementRole" roleKey="propertyManagementRole" data={propertyManagementRoles} />
          <Roles roleTitle="Leasing Roles" roleIndex="leasingRole" roleKey="leasingRole" data={leasingRoles} />
          <Roles roleTitle="Maintenance Roles" roleIndex="maintenanceRole" roleKey="maintenanceRole" data={maintenanceRoles} />
          <Roles roleTitle="Misc. Support Roles" roleIndex="miscSupportRole" roleKey="miscSupportRole" data={miscSupportRoles} />
        </Col>
       </Row>
       <Footer />
      </div>
    </div>
    <div className="RightSidebar">
      <RightBar RightBarData={UserRolesAndPermissionsRightBar} />
    </div>
    </>
  )
}

export default ManageRoles;
